import { getUserActions, GetUserActionsResponse } from '../api';
import { useLocation } from 'react-router-dom';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

export interface UseUserActionsRequest {
  isEnabled?: boolean;
  orgId?: string | null;
  shipmentId?: string | null;
  userId?: string | null;
}

export const useUserActions = (payload: UseUserActionsRequest): UseQueryResult<GetUserActionsResponse> => {
  const {
    isEnabled = true,
    orgId,
    shipmentId,
    userId
  } = payload;

  const location = useLocation();

  return useQuery({
    enabled: Boolean(isEnabled && userId),
    queryFn: () => {
      if (!userId) {
        return Promise.resolve([]);
      }

      return getUserActions({
        ...(orgId ? { org_id: orgId } : {}),
        ...(shipmentId ? { shipment_id: shipmentId } : {}),
        user_id: userId
      });
    },
    queryKey: ['getUserActions', location.pathname, orgId, shipmentId, userId],
    retry: 1
  });
};